
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { Getter } from 'vuex-class';

  import Select from '../../types/app/generic/select';
  import Endpoint from '../../utils/endpoint';
  import Entity from '@/src/types/entities/entity';

  @Component({})
  export default class TaxTypeComponent extends Vue {
    endpoint = new Endpoint();

    @Getter('getOriginalEntity', { namespace: 'entity' }) originalEntity!: Entity;
    @Getter('getEntity', { namespace: 'entity' })
    entity!: Entity;

    @Prop({ type: Array })
    rules;

    @Prop({ type: Array })
    dateRules;

    taxTypes: Array<Select> = [];

    async created() {
      await this.getTaxTypesAsync();
    }

    get originalStartDate(): string | null {
      if (this.originalEntity.taxPayer.effectiveStartDate !== null) {
        const dt = new Date(this.originalEntity.taxPayer.effectiveStartDate);
        return this.$formatDate(dt);
      }

      return null;
    }

    get startDate(): string | null {
      return this.$formatDate(this.entity.taxPayer.effectiveStartDate);
    }
    set startDate(value: string | null) {
      this.entity.taxPayer.effectiveStartDate = this.$parseDate(value);
    }

    async getTaxTypesAsync(): Promise<void> {
      const response = await this.$http.get(`${this.endpoint.general.getByTable}/taxtypes/id/txname`);

      if (response.status === 200) {
        this.taxTypes = response.data;
      }
    }
  }
